var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comp-4-house-goal',{attrs:{"page":8,"goal":6,"audio":true}})}
var staticRenderFns = []

export { render, staticRenderFns }